import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import InputTag from "./InputTag";

const TextInput = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    required,
    disabled,
  } = item;

  const [quantityCount, setCount] = useState(multipleData);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: type,
        name: "",
        defaultValue: [],
      },
    ]);
  };

  return (
    <div className="col-span-3 md:col-span-2 lg:col-span-1 flex flex-row gap-4 items-centers w-full fitHeight  ">
      <div className="col-span-2 w-full ">
        {multipleData ? (
          quantityCount.map((item, index) => (
            <InputTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              type={type}
              multiple={multiple}
              required={required}
              disabled={disabled}
            />
          ))
        ) : (
          <InputTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
            disabled={disabled}
          />
        )}
      </div>

      {multiple && (
        <div
          className={`${
            quantityCount.length > 0 ? "-mt-16" : "mt-16"
          } flex justify-start w-full items-end`}
        >
          <div
            onClick={handleAddElement}
            className="flex gap-2 border rounded-full border-gray-800 py-1 px-4 pr-1"
          >
            <label className="label cursor-pointer">
              <span className="text-base font-semibold whitespace-nowrap">
                Add {label}
              </span>
            </label>
            <button
              onClick={handleAddElement}
              type="button"
              className="btn btn-circle"
            >
              <BsPlusLg />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TextInput;
